import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationCountService {
  private notificationCount = new BehaviorSubject<number>(0);
  notificationCount$ = this.notificationCount.asObservable();

  updateCount(count: number) {
    this.notificationCount.next(count);
  }

  getValue(): number {
    return this.notificationCount.getValue();
  }
}
